/* eslint-disable max-len */
import 'react';

const SidebarArrowRightSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="8px" height="10px" viewBox="0 0 8 10" version="1.1" fill="currentColor" {...props}>
        <g id="控件" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="切图" transform="translate(-182.000000, -57.000000)" fill="currentColor" fillRule="nonzero">
                <g id="编组备份" transform="translate(185.000000, 62.000000) scale(-1, 1) translate(-185.000000, -62.000000) translate(180.000000, 57.000000)">
                    <path d="M7.89619408,1.64619408 C8.31040764,1.64619408 8.64619408,1.98198052 8.64619408,2.39619408 C8.64619408,2.77588984 8.3640402,3.08968504 7.99796464,3.13934746 L7.89619408,3.14619408 L3.64566017,3.14566017 L3.64619408,7.39619408 C3.64619408,7.77588984 3.3640402,8.08968504 2.99796464,8.13934746 L2.89619408,8.14619408 C2.51649831,8.14619408 2.20270312,7.8640402 2.15304069,7.49796464 L2.14619408,7.39619408 L2.14619408,2.39619408 C2.14619408,2.01649831 2.42834796,1.70270312 2.79442352,1.65304069 L2.89619408,1.64619408 L7.89619408,1.64619408 Z" id="路径" transform="translate(5.396194, 4.896194) rotate(-45.000000) translate(-5.396194, -4.896194) "></path>
                </g>
            </g>
        </g>
    </svg>
);
export default SidebarArrowRightSvg;
